import { Component, ojs, app } from "modular-openscriptjs";
import GlobalModal from "../GlobalModal";
import OffCanvasNav from "../OffCanvasNav";
import { gc, uc } from "../../ojs.contexts";
import AddressPicker from "../Modals/AddressPicker";
import Confirmation from "../Confirmation";
import TermsAndConditionsForm from "../Forms/TermsAndConditionsForm";
import AppReviewPromptModal from "../Modals/AppReviewPromptModal";
import FeatureAnnouncementModal from "../Modals/FeatureAnnouncementModal";
import AddToHomescreenModal from "../Modals/AddToHomescreenModal";
import DepositAiCreditForm from "../Forms/DepositAiCreditForm";
import BusinessVoiceOrderCallModal from "../Modals/BusinessVoiceOrderCallModal";

const h = app("h");

ojs(OffCanvasNav, GlobalModal, AddressPicker, Confirmation, TermsAndConditionsForm, AppReviewPromptModal, FeatureAnnouncementModal, AddToHomescreenModal, DepositAiCreditForm, BusinessVoiceOrderCallModal);

export default class AppOffCanvas extends Component {
    render(...args) {
        return h.wrapper(
            h.GlobalModal(),
            h.OffCanvasNav(gc.auth, uc.permissions, uc.roles),
            h.AddressPicker(),
            h.Confirmation(),
            h.TermsAndConditionsForm(),
            h.AppReviewPromptModal(),
            h.FeatureAnnouncementModal(),
            h.AddToHomescreenModal(),
            h.DepositAiCreditForm(),
            h.BusinessVoiceOrderCallModal(),
            ...args,
        );
    }

    cleanUp() {
        super.cleanUp();
        let markup = this.markup();

        for (let elem of markup) {
            disposeBootstrapTree(elem);
        }
    }
}

ojs(AppOffCanvas);
